import { Badge, Group, Stack, Tooltip } from '@mantine/core';
import P2Medium from 'components/typography/P2Medium';
import P3Regular from 'components/typography/P3Regular';
import P3Medium from 'components/typography/P3Medium';
import { DeviceRevisionGetOptionsResponse } from 'api/actions/device-revision-get-options/device-revision-get-options-response';
import { useMemo } from 'react';
import P2Regular from 'components/typography/P2Regular';

interface DeviceCheckboxLabelProps {
  device: DeviceRevisionGetOptionsResponse[number];
  revisionDeviceTypeId: number;
  revisionDeviceTypeName: string;
}

/**
 * Component for rendering a device in the list of devices to pick from.
 */
export default function DeviceCheckboxLabel({
  device: { deviceId, deviceName, serialNumber, building, deviceTypeId, parentDevice, childDevices = [] },
  revisionDeviceTypeId,
  revisionDeviceTypeName,
}: DeviceCheckboxLabelProps) {
  const eligibleChildDevices = useMemo(
    () => childDevices.filter((child) => child.deviceTypeId === revisionDeviceTypeId),
    [childDevices, revisionDeviceTypeId]
  );

  return (
    <Stack spacing={0}>
      <Group spacing={8} align="center">
        <Group spacing={4} noWrap align="center">
          {!!parentDevice && (
            <P2Regular mb={-2} color="gray.7">
              {parentDevice.deviceName} /
            </P2Regular>
          )}
          <P2Medium mb={-2}>{deviceName}</P2Medium>
        </Group>
        {eligibleChildDevices.length > 0 && (
          <Tooltip
            withinPortal
            openDelay={200}
            label={
              <Stack spacing={0}>
                <P3Medium>Nadradené zariadenie</P3Medium>
                {eligibleChildDevices.map((childDevice) => (
                  <P3Regular key={childDevice.deviceId}>
                    ↳ {childDevice.deviceName} (ID: {childDevice.deviceId})
                  </P3Regular>
                ))}
              </Stack>
            }
          >
            <Badge color="red" variant="filled" size="xs" mt={1}>
              + {eligibleChildDevices.length}
            </Badge>
          </Tooltip>
        )}
        {revisionDeviceTypeId !== deviceTypeId && <P2Medium>(Termín - {revisionDeviceTypeName})</P2Medium>}
      </Group>
      <Group spacing={4} pl={2}>
        <P3Regular color="gray.7">ID: {deviceId}</P3Regular>
        {!!serialNumber && (
          <>
            <P3Regular color="gray.7">•</P3Regular>
            <P3Regular color="gray.7">VČ: {serialNumber}</P3Regular>
          </>
        )}
        {!!building && (
          <>
            <P3Regular color="gray.7">•</P3Regular>
            <P3Regular color="gray.7">{building}</P3Regular>
          </>
        )}
      </Group>
    </Stack>
  );
}
